import React from "react";

/**
 * Renders `m2` / `m3` (and spaced variants) as m with a numeric superscript, matching specifications tables.
 * @param {string} text
 * @returns {import("react").ReactNode}
 */
export function formatUnitSuperscriptText(text) {
  const value = String(text || "");
  const unitRegex = /m\s*([23])\b/gi;
  const rendered = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = unitRegex.exec(value)) !== null) {
    const matchStart = match.index;
    if (matchStart > lastIndex) {
      rendered.push(value.slice(lastIndex, matchStart));
    }

    rendered.push(
      <React.Fragment key={`unit-sup-${key++}`}>
        m<sup>{match[1]}</sup>
      </React.Fragment>
    );

    lastIndex = unitRegex.lastIndex;
  }

  if (lastIndex < value.length) {
    rendered.push(value.slice(lastIndex));
  }

  return rendered.length ? rendered : value;
}
